import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';
import { ContestAdd } from '../components/ContestAdd';

export const Route = createFileRoute('/prize-settings_/add')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <h1>Add Prize</h1>
        <ContestAdd />
      </Pane>
    </>
  );
}
